import { Box, Button, LinearProgress, Stack } from '@lingoda/ui';
import { styled } from '@lingoda/ui/theme';
import SectionWrapper from './SectionWrapper';
import type { FC } from 'react';

interface Props {
    onClick: () => void;
    loading: boolean;
    isValid: boolean;
    submitLabel: string;
}

const StickyContainer = styled(Box)(({ theme }) => ({
    [theme.breakpoints.down('sm')]: {
        width: '100%',
        position: 'fixed',
        bottom: 0,
        left: 0,
        backgroundColor: theme.colors.background.default,
        zIndex: theme.zIndex.drawer,
        boxShadow: theme.shadows[3],
        padding: theme.spacing(3, 0),
    },
}));

const ConfirmSection: FC<Props> = ({ submitLabel, loading, isValid, onClick }) => {
    return (
        <StickyContainer>
            <Stack spacing={2}>
                <SectionWrapper>
                    <Button
                        color="primary"
                        variant="contained"
                        size="large"
                        type="submit"
                        fullWidth
                        disabled={loading || !isValid}
                        onClick={onClick}
                        data-cy="submit-payment"
                    >
                        {submitLabel}
                    </Button>
                </SectionWrapper>

                {loading && (
                    <Box mb={2}>
                        <LinearProgress />
                    </Box>
                )}
            </Stack>
        </StickyContainer>
    );
};

export default ConfirmSection;
